function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,2466.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16460 23349 c-2692 -719 -4895 -1309 -4896 -1309 -1 0 -327 -574 -725 -1276 l-724 -1275 -550 5 c-302 3 -966 8 -1475 11 l-925 6 -3580 -3570 c-1969 -1963 -3580 -3576 -3580 -3584 0 -9 1613 -1623 3584 -3587 l3585 -3573 310 7 c171 3 833 9 1471 12 l1160 6 725 -1274 724 -1274 4896 -1307 c2692 -719 4900 -1307 4905 -1307 6 0 601 2198 1323 4885 l1313 4884 -727 1233 c-399 678 -735 1247 -745 1264 l-18 30 745 1264 745 1264 -1313 4885 c-722 2686 -1318 4885 -1323 4887 -6 1 -2213 -587 -4905 -1307z m1267 -2553 c-62 -106 -1028 -1775 -2147 -3709 l-2035 -3516 -4295 -1 -4294 0 60 63 c292 298 5329 5424 5338 5430 6 5 1692 440 3746 967 2054 527 3736 959 3737 959 1 1 -48 -86 -110 -193z m3263 -4750 l1032 -3689 -1031 -3686 c-567 -2027 -1035 -3694 -1039 -3705 -6 -14 -496 823 -2151 3680 -1179 2035 -2144 3704 -2144 3709 0 6 964 1676 2144 3713 1481 2558 2146 3696 2150 3684 4 -9 471 -1677 1039 -3706z m-5303 -8604 c1180 -2037 2144 -3704 2142 -3706 -2 -2 -1684 427 -3737 953 l-3734 956 -2275 2315 c-1251 1273 -2469 2512 -2705 2753 l-430 437 4297 -2 4297 -3 2145 -3703z"
}));

const SvgUnity = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "2400.000000pt",
  height: "2466.000000pt",
  viewBox: "0 0 2400.000000 2466.000000",
  preserveAspectRatio: "xMidYMid meet",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnity, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/unity.219ee0c5.svg";
export { ForwardRef as ReactComponent };